import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { getActivityTemplateCode } from '../../slices/thunks';


const useActivityTemplate = (code) => {
    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.Activities,
        data => ({
            itemActivityTemplateDetail: data.itemActivityTemplateDetail,
        })
    );

    const { itemActivityTemplateDetail } = useSelector(selector);

    useEffect(() => {
        dispatch(getActivityTemplateCode(code));
    }, [dispatch]);
    return { itemActivityTemplateDetail };
}

export default useActivityTemplate;